import React from "react";
// Chakra imports
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import InnerContent from "layouts/innerContent";
import center from "assets/img/floating-elements-contact.png";
import Form from "components/form/Form";

export default function Contact() {
	// Chakra Color Mode

	const textColor = useColorModeValue("#09090B", "white");
	return (
		<Flex
			zIndex='2'
			w='100%'
			direction={{ base: "column" }}
			bgSize='cover'
			position='relative'>
			<InnerContent px={{ base: "20px", md: "40px", xl: "0px" }} maxW='100%'>
				<Flex direction='column' width='stretch'>
					<Flex
						direction='column'
						mx='auto'
						mb={{ base: "40px", md: "60px", xl: "60px" }}
						alignItems='center'
						textAlign='center'>
						<Text
							as='h3'
							textAlign={{ base: "center", lg: "center" }}
							fontWeight='700'
							letterSpacing='2px'
							color={textColor}
							fontSize={{ base: "xs", md: "md" }}
							w='100%'
							mb='10px'>
							GET IN TOUCH WITH US
						</Text>
						<Text
							as='h2'
							textAlign={{ base: "center" }}
							color={textColor}
							fontWeight='800'
							fontSize={{ base: "28px", md: "38px", lg: "38px", xl: "38px" }}
							lineHeight={{ base: "40px", md: "50px", lg: "50px", xl: "50px" }}
							mb={{ base: "20px", md: "30px" }}
							w={{
								base: "100%",
								md: "70%",
								lg: "100%",
								xl: "100%",
								"2xl": "100%",
							}}
							mx='auto'>
							Let’s make your project possible, together.
						</Text>
						<Text
							color='#52525B'
							fontSize={{ base: "md", md: "md", xl: "lg" }}
							fontWeight='500'
							letterSpacing='0px'
							lineHeight={{ base: "24px", md: "30px" }}
							w={{
								base: "92%",
								md: "100%",
								lg: "100%",
								xl: "100%",
								"2xl": "100%",
							}}>
							Give us ~3 minutes of your time and we’ll get back to you as soon
							as possible.
						</Text>
					</Flex>
					<Flex
						w={{ lg: "100%", "2xl": "774px" }}
						h='100%'
						p={{ base: "20px", md: "60px" }}
						borderRadius={{ base: "20px", md: "40px" }}
						bg='linear-gradient(180deg, #F4F4F5 0%, rgba(255, 255, 255, 0.00) 92.26%)'>
						<Form />
					</Flex>
					<Image
						display={{ base: "none", md: "flex" }}
						alt='react nextjs boilerplate dashboard template technologies preview'
						// ms='-290px'
						top={{ base: "40%", md: "43%", lg: "46%", xl: "48%", "2xl": "48%" }}
						transform='translate(0px, -50%)'
						right={{
							base: "-40px",
							md: "-90px",
							lg: "-60px",
							xl: "140px",
							"2xl": "280px",
							"3xl": "380px",
						}}
						position='absolute'
						borderRadius={{ base: "4px", md: "10px" }}
						maxW={{
							base: "400px",
							md: "960px",
							lg: "1150px",
							xl: "1200px",
							"2xl": "1200px",
						}}
						zIndex='2'
						src={center}
					/>
				</Flex>
			</InnerContent>
		</Flex>
	);
}
